import {Palette} from 'hubbl-shared';
import {memo} from 'react';
import styled, {keyframes} from 'styled-components';

interface AnimatedWaitingDotsProps {
  text: string;
  textColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

const tickAnimation = keyframes`
  0%, 33% {
    content: '.';
  }
  34%, 66% {
    content: '..';
  }
  67%, 100% {
    content: '...';
  }
`;

const WaitingText = styled.span<{$textColor: string}>`
  color: ${({$textColor}) => $textColor};
  font-style: italic;
  position: relative;

  &::after {
    content: '.';
    animation: ${tickAnimation} 1.5s infinite;
    display: inline-block;
    width: 1.2em;
    text-align: left;
  }
`;

export const AnimatedWaitingDots = memo(
  ({
    text,
    textColor = Palette.almostBlack750,
    className,
    style,
  }: AnimatedWaitingDotsProps) => {
    return (
      <WaitingText className={className} style={style} $textColor={textColor}>
        {text}
      </WaitingText>
    );
  },
);
